import { createAction, handleActions } from 'redux-actions';

export const types = {
  subscriptionHandleForm: 'SUBSCRIPTION_HANDLE_FORM',
  handleSubscriptionFormValidating: 'HANDLE_SUBSCRIPTION_FORM_VALIDATING',
  handleSubscriptionFormError: 'HANDLE_SUBSCRIPTION_FORM_ERROR',
  handleSubscriptionFormValid: 'HANDLE_SUBSCRIPTION_FORM_VALID',
  handleSubscriptionFormUser: 'HANDLE_SUBSCRIPTION_FORM_USER',
  handleSubscriptionFormRegister: 'HANDLE_SUBSCRIPTION_FORM_REGISTER',
  handleSubscriptionFormSuccess: 'HANDLE_SUBSCRIPTION_FORM_SUCCESS',
};

export const subscriptionHandleForm = createAction(types.subscriptionHandleForm);

export const handleSubscriptionFormValidating = createAction(types.handleSubscriptionFormValidating);

export const handleSubscriptionFormError = createAction(types.handleSubscriptionFormError);

export const handleSubscriptionFormValid = createAction(types.handleSubscriptionFormValid);

export const handleSubscriptionFormUser = createAction(types.handleSubscriptionFormUser);

export const handleSubscriptionFormRegister = createAction(types.handleSubscriptionFormRegister);

export const handleSubscriptionFormSuccess = createAction(types.handleSubscriptionFormSuccess);

export const INITIAL_STATE = {
  user: null,
  subscription: {},
  validating: false,
  valid: false,
  error: '',
  message: '',
};

export const subscriptionFormReducer = handleActions(
  {
    [types.subscriptionHandleForm]: state => ({
      ...state,
      valid: false,
    }),
    [types.handleSubscriptionFormValidating]: state => ({
      ...state,
      validating: true,
      valid: false,
    }),
    [types.handleSubscriptionFormError]: (state, action) => ({
      ...state,
      error: action.payload.error,
      validating: false,
      valid: false,
    }),
    [types.handleSubscriptionFormValid]: (state, action) => ({
      ...state,
      subscription: action.payload.subscription,
      error: '',
      validating: false,
      valid: true,
    }),
    [types.handleSubscriptionFormUser]: (state, action) => ({
      ...state,
      user: action.payload.user,
    }),
    [types.handleSubscriptionFormRegister]: (state, action) => ({
      ...state,
      subscriptionID: action.payload.subscriptionID,
      planId: action.payload.planId,
      typePaypal: action.payload.typePaypal,
    }),
    [types.handleSubscriptionFormSuccess]: (state, action) => ({
      ...state,
      subscription: {},
      message: 'Completed registration',
    }),
  },
  INITIAL_STATE
);
